export const TO_BE_COPIED_ID = 'TO_BE_COPIED_ID'
